import React from 'react';
import { Box, Burger, Group, UnstyledButton } from '@mantine/core';
import { PersonByEmail } from './PersonByEmail';
import { IDynamicPerson } from '@microsoft/mgt-react';
import { useCurrentUser } from '@repo/utils';

/**
 * A header bar component with a logo, burger menu toggle, current user's email badge, and support for custom menu items and extra action buttons.
 *
 * The `search` slot is an app-provided node (e.g. the map search drawer). It lives
 * as an injected prop rather than an import so this shared package never depends on
 * app-level code (map context, app shell, etc.).
 */
export function AppHeader({ hasBurgerMenuOptions = false, opened, toggle, logoImg, onLogoClick, customMenu, extraActions, search }: { hasBurgerMenuOptions?: boolean; opened: boolean; toggle: () => void; logoImg: React.ReactNode; onLogoClick: () => void; customMenu?: React.ReactNode; extraActions?: React.ReactNode; search?: React.ReactNode }) {
  const {currentUser} = useCurrentUser();

  return (
    <Box pl={'xs'} pr={'xs'} h="100%">
      <Group justify="space-between" gap="xs" w={'100%'} h={'100%'}>
        {hasBurgerMenuOptions && (
          <Burger
            opened={opened}
            onClick={toggle}
            hiddenFrom="lg"
            size="sm"
          />
        )}
        <UnstyledButton onClick={onLogoClick}>
          {logoImg && logoImg}
        </UnstyledButton>
        <Group gap="sm" align="center" wrap="nowrap">
          {search}
          {extraActions}
          {/* @ts-expect-error CSS custom property is not in React.CSSProperties */}
          <div style={{ paddingTop: "7px", zIndex: 1 , '--person-avatar-size':"40px", flexShrink: 0 }}>
            {customMenu ? (
              customMenu
            ) : (
              <PersonByEmail
                //@ts-expect-error mgt-react view prop typing
                view={'image'}
                avatarSize='large'
                fallbackDetails={{ mail: 'Loading Team Member...', displayName: currentUser?.displayName } as IDynamicPerson}
                personCardInteraction={'click'}
                showPresence
                email={currentUser?.userPrincipalName || ''}
              />
            )}
          </div>
        </Group>
      </Group>
    </Box>
  );
}
